const LAST_KEY = 'kcn_tenant_pay_room_code';

function keyed(userId: string) {
  return `${LAST_KEY}_${userId}`;
}

export function saveTenantPayRoomCode(userId: string, payRoomCode: string) {
  const code = (payRoomCode || '').trim();
  if (!code) return;
  try {
    localStorage.setItem(LAST_KEY, code);
    if (userId) localStorage.setItem(keyed(userId), code);
  } catch {
    // ignore quota / private mode
  }
}

export function getTenantPayRoomCode(userId?: string | null): string | null {
  try {
    if (userId) {
      const stored = localStorage.getItem(keyed(userId));
      if (stored) return stored;
    }
    return localStorage.getItem(LAST_KEY);
  } catch {
    return null;
  }
}

/** Xóa mã phòng đã lưu — sau đăng xuất khách thuê phải quét QR lại. */
export function clearTenantPayRoomCode(userId?: string | null): void {
  try {
    localStorage.removeItem(LAST_KEY);
    if (userId) {
      localStorage.removeItem(keyed(userId));
    }
  } catch {
    // ignore
  }
}
